import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ChangePageButtonComponent } from "../../components/changePageButtons";
import { CommonFunctionalityComponent } from "../../components/CommonFunctionalityComponent";
import { MemberDetailsLayout } from "../../../layouts/admin/members/details/MemberDetailsLayout";
import { countAssessmentSharedByMember } from "../../../redux/slices/CountAssessmentSharedByMemberSlice";
import { countFeedbackRequestReceivedByMember } from "../../../redux/slices/CountRequestReceivedByMemberSlice";
import { countRequestSendByMember } from "../../../redux/slices/CountRequestSentByMemberSlice";
import { getAllReceivedRequestsByMember } from "../../../redux/slices/FeedbackRequestReceivedByMemberSlice";
import { getAllSendRequestsByMember } from "../../../redux/slices/FeedbackRequestsSentByMemberSlice";
import { getAllCountSharedAndReceivedFeedback } from "../../../redux/slices/ReceivedAndSharedAllCountSlice";
import { getCountSharedAndReceivedFeedback } from "../../../redux/slices/ReceivedAndSharedCountSlice";
import { receivedFeedbackListByMember } from "../../../redux/slices/ReceivedFeedbackListByMemberSlice";
import { getSharedAssessmentListByMember } from "../../../redux/slices/SharedAssessmentListByMemberSlice";
import { getSharedFeedbackListByMember } from "../../../redux/slices/SharedFeedbackListByMemberSlice";
import {
  CountProps,
  Counts,
  DeactivateMemberProp,
  FeedbackListSliceProps,
  FeedbackRequestListSliceProps,
  State,
} from "../../../type";
import { DetailSectionView } from "../../admin/members/details/DetailSection";
import { ListHeaderWithContent } from "../../admin/members/details/List";
import { TabsWithReportCTA } from "../../admin/members/details/tabsAndReportBar";
import { UserTypes } from "../../../enums/userTypes";
import { HttpStatus } from "../../../enums/httpStatus";
import { RequestTags } from "../../../enums/requestTags";

export const TeamLeadMemberDetails = (props) => {
  const dispatch = useDispatch();
  const { id } = props.match.params;
  const member = props.location.state?.member;
  const pageNo = props.location.state?.pageNumber;
  const tabNo = props.location.state?.tabValue;
  const itemNo = props.location.state?.itemValue;
  const from = props.location.state?.from;
  const teamId = props.location.state?.teamId;
  const [logout, setLogout] = React.useState<Boolean>(false);
  const [isDetailView, setIsDetailView] = React.useState<Boolean>(true);
  const [pageNumber, setPageNumber] = React.useState<number>(
    pageNo ? pageNo : 1
  );
  const [tabValue, setTabValue] = React.useState<number>(tabNo ? tabNo : 0);
  const [itemValue, setItemValue] = React.useState<number>(itemNo ? itemNo : 1);
  const [open, setOpen] = React.useState<Boolean>(false);

  const [feedbackOrAssessmentId, setFeedbackOrAssessmentId] =
    React.useState<number>(0);
  const history = useHistory();

  useEffect(() => {
    const arg: DeactivateMemberProp = {
      memberId: id,
      tag: itemValue === 1 ? RequestTags.ANY : itemValue === 2 ? RequestTags.INTERNAL : RequestTags.EXTERNAL,
    };
    dispatch(getAllCountSharedAndReceivedFeedback(arg));
    dispatch(countFeedbackRequestReceivedByMember(arg));
    dispatch(countRequestSendByMember(arg));
    dispatch(countAssessmentSharedByMember(arg));
  }, []);

  useEffect(() => {
    const arg: DeactivateMemberProp = {
      memberId: id,
      tag: itemValue === 1 ? RequestTags.ANY : itemValue === 2 ? RequestTags.INTERNAL : RequestTags.EXTERNAL,
    };
    if (tabValue === 0) {
      dispatch(getCountSharedAndReceivedFeedback(arg));
    } else if (tabValue === 3) {
      dispatch(countRequestSendByMember(arg));
    }
  }, [itemValue]);

  useEffect(() => {
    if (tabValue === 0) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        tag: RequestTags.ANY,
      };
      dispatch(receivedFeedbackListByMember(arg));
    } else if (tabValue === 1) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
      };
      dispatch(getSharedFeedbackListByMember(arg));
    } else if (tabValue === 2) {
      const arg: FeedbackRequestListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        status: "PENDING",
        tag: RequestTags.ANY,
      };
      dispatch(getAllReceivedRequestsByMember(arg));
    } else if (tabValue === 3) {
      const arg: FeedbackRequestListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        status: "PENDING",
          tag: itemValue === 1 ? RequestTags.ANY : itemValue === 2 ? RequestTags.INTERNAL : RequestTags.EXTERNAL,
      };
      dispatch(getAllSendRequestsByMember(arg));
    } else if (tabValue === 4) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
      };
      dispatch(getSharedAssessmentListByMember(arg));
    }
  }, [tabValue]);

  useEffect(() => {
    if (tabValue === 0) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        tag: itemValue === 1 ? RequestTags.ANY : itemValue === 2 ? RequestTags.INTERNAL : RequestTags.EXTERNAL,
      };
      dispatch(receivedFeedbackListByMember(arg));
    } else if (tabValue === 1) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
      };
      dispatch(getSharedFeedbackListByMember(arg));
    } else if (tabValue === 2) {
      const arg: FeedbackRequestListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        status: "PENDING",
        tag: RequestTags.ANY,
      };
      dispatch(getAllReceivedRequestsByMember(arg));
    } else if (tabValue === 3) {
      const arg: FeedbackRequestListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
        status: "PENDING",
        tag: itemValue === 1 ? RequestTags.ANY : itemValue === 2 ? RequestTags.INTERNAL : RequestTags.EXTERNAL,
      };
      dispatch(getAllSendRequestsByMember(arg));
    } else if (tabValue === 4) {
      const arg: FeedbackListSliceProps = {
        memberId: id,
        offSet: (pageNumber - 1) * 5,
        count: 5,
      };
      dispatch(getSharedAssessmentListByMember(arg));
    }
  }, [pageNumber, itemValue]);

  const counts: CountProps = useSelector(
    (state: State) => state.countSharedAndReceivedFeedback?.data
  );
  const allCounts: CountProps = useSelector(
    (state: State) => state.countAllSharedAndReceived?.data
  );

  const requestReceivedCount: Counts | null = useSelector(
    (state: State) => state.countRequestReceivedByMember.data
  );

  const requestSentCount: number | null = useSelector(
    (state: State) => state.countRequestSendByMember.data
  );

  const countAssessments: number | null = useSelector(
    (state: State) => state.countAssessmentSharedByMember.data
  );
  const statusCode: number | null = useSelector((state: State) =>
    state.countSharedAndReceivedFeedback.status !== HttpStatus.OK
      ? state.countSharedAndReceivedFeedback.status
      : state.countAllSharedAndReceived.status !== HttpStatus.OK
      ? state.countAllSharedAndReceived.status
      : state.countRequestReceivedByMember.status !== HttpStatus.OK
      ? state.countRequestReceivedByMember.status
      : state.countRequestSendByMember.status !== HttpStatus.OK
      ? state.countRequestSendByMember.status
      : state.receivedFeedbackListByMember.status !== HttpStatus.OK
      ? state.receivedFeedbackListByMember.status
      : state.sharedFeedbackListByMember.status !== HttpStatus.OK
      ? state.sharedFeedbackListByMember.status
      : state.allReceivedRequestsByMember.status !== HttpStatus.OK
      ? state.allReceivedRequestsByMember.status
      : state.allSendRequestsByMember.status !== HttpStatus.OK
      ? state.allSendRequestsByMember.status
      : state.countAssessmentSharedByMember.status !== HttpStatus.OK
      ? state.countAssessmentSharedByMember.status
      : state.sharedAssessmentListByMember.status !== HttpStatus.OK
      ? state.sharedAssessmentListByMember.status
      : state.changeMemberAccessRole.status !== HttpStatus.OK
      ? state.changeMemberAccessRole.status
      : null
  );

  const renderErrorModal = () => (
    <CommonFunctionalityComponent
      props={props}
      logout={logout}
      setLogout={setLogout}
      statusCode={statusCode}
    />
  );

  const renderDetailSection = () => (
    <DetailSectionView
      firstName={member?.firstName}
      lastName={member?.lastName}
      imageUrl={member?.imageUrl}
      status={member?.status}
      id={member?.id}
      joiningDate={member?.joiningDate}
      emailId={member?.emailId}
      user_role={member?.userType}
    ></DetailSectionView>
  );

  const renderTabsWithReportCTA = () => (
    <TabsWithReportCTA
      tabValue={tabValue}
      setTabValue={setTabValue}
      setOpen={setOpen}
      setPageNumber={setPageNumber}
      setItemValue={setItemValue}
      member={member}
    />
  );

  const renderList = () => (
    <ListHeaderWithContent
      tabValue={tabValue}
      setFeedbackOrAssessmentId={setFeedbackOrAssessmentId}
      itemValue={itemValue}
      setItemValue={setItemValue}
      setPageNumber={setPageNumber}
    />
  );

  const renderChangePageComponent = () => (
    <Grid xs={12} item container justify="flex-end" alignItems="center">
      {tabValue === 0 && counts?.receivedCount > 0 && (
        <ChangePageButtonComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          pageCount={Math.ceil(counts?.receivedCount / 5)}
          userRole={UserTypes.ADMIN}
        />
      )}
      {tabValue === 1 && allCounts?.sharedCount > 0 && (
        <ChangePageButtonComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          pageCount={Math.ceil(allCounts?.sharedCount / 5)}
          userRole={UserTypes.ADMIN}
        />
      )}
      {tabValue === 2 &&
        requestReceivedCount &&
        requestReceivedCount?.pendingRequestCount > 0 && (
          <ChangePageButtonComponent
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            pageCount={Math.ceil(requestReceivedCount?.pendingRequestCount / 5)}
            userRole={UserTypes.ADMIN}
          />
        )}
      {tabValue === 3 && requestSentCount && requestSentCount > 0 && (
        <ChangePageButtonComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          pageCount={Math.ceil(requestSentCount / 5)}
          userRole={UserTypes.ADMIN}
        />
      )}
      {tabValue === 4 && countAssessments && countAssessments > 0 && (
        <ChangePageButtonComponent
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          pageCount={Math.ceil(countAssessments / 5)}
          userRole={UserTypes.ADMIN}
        />
      )}
    </Grid>
  );

  if (!isDetailView) {
    history.push({
      pathname: `/teams/details/${teamId}`,
    });
  }

  if (open) {
    history.push({
      pathname: `/members/report/feedback/received/${id}`,
      state: {
        memberName: `${member.firstName} ${member.lastName}`,
        member: member, teamId: teamId
      },
    });
  }

  if (feedbackOrAssessmentId > 0) {
    history.replace({
      pathname: `/member/detail/${id}`,
      state: {
        member: member,
        tabValue: tabValue,
        pageNumber: pageNumber,
        itemValue: itemValue,
        teamId: teamId
      },
    });
    history.push({
      pathname: `/detail/view`,
      state: {
        feedbackOrAssessmentId: feedbackOrAssessmentId,
        memberId: id,
        tabValue: tabValue,
        member: member,
        pageNumber: pageNumber,
        itemValue: itemValue,
        teamId: teamId
      },
    });
  }

  return (
    <MemberDetailsLayout
      props={props}
      memberName={`${member?.firstName} ${member?.lastName}`}
      isDetailView={isDetailView}
      setIsDetailView={setIsDetailView}
      loading={false}
      setLogout={setLogout}
      renderErrorModal={renderErrorModal}
      renderDetailSection={renderDetailSection}
      renderTabsWithReport={renderTabsWithReportCTA}
      renderList={renderList}
      renderChangePageComponent={renderChangePageComponent}
    ></MemberDetailsLayout>
  );
};
